import { api } from './base';

export type ApiKeyKind = 'personal' | 'service';

export interface ApiKey {
  id: string;
  name: string;
  kind: ApiKeyKind;
  prefix: string;
  userId: string;
  ownerName: string | null;
  createdBy: string;
  scopes: string[];
  canWrite: boolean;
  allowedIps: string[] | null;
  expiresAt: string;
  lastUsedAt: string | null;
  lastUsedIp: string | null;
  revokedAt: string | null;
  createdAt: string | null;
}

export interface GrantableScope {
  key: string;
  label: string;
  group: string;
}

export interface PersonalKeysAvailability {
  available: boolean;
  reason: string | null;
}

export interface CreateApiKeyDto {
  name: string;
  scopes: string[];
  canWrite: boolean;
  expiresInDays: number;
  allowedIps?: string[] | null;
}

export interface CreateServiceKeyDto extends CreateApiKeyDto {
  accountName: string;
  role: string;
}

export interface IssuedApiKey {
  key: ApiKey;
  token: string;
}

export const apiKeysApi = {
  listMine: () =>
    api.get<{ keys: ApiKey[]; grantable: GrantableScope[]; personal?: PersonalKeysAvailability }>(
      '/api/v1/users/me/api-keys',
    ),
  createMine: (dto: CreateApiKeyDto) => api.post<IssuedApiKey>('/api/v1/users/me/api-keys', dto, { toast: false }),
  revokeMine: (id: string) => api.post<ApiKey>(`/api/v1/users/me/api-keys/${id}/revoke`, {}),

  listAll: () =>
    api.get<{
      keys: ApiKey[];
      grantable: GrantableScope[];
      roles: { key: string; name: string }[];
      personal?: PersonalKeysAvailability;
    }>(
      '/api/v1/admin/api-keys',
    ),
  createService: (dto: CreateServiceKeyDto) =>
    api.post<IssuedApiKey>('/api/v1/admin/api-keys', dto, { toast: false }),
  revokeAny: (id: string) => api.post<ApiKey>(`/api/v1/admin/api-keys/${id}/revoke`, {}),
};
